export const load = () => ({
	title: 'Case Study House #26 Blocks Cold Air from its Windows',
	showTitle: true,
});
